import { css } from "@compiled/react";
// @ts-ignore
import { useInView } from "react-intersection-observer";
import { useIntl } from "react-intl";

import {
    JiraOverlayTemplate,
    JPDOverlayTemplate
} from "@/components/signup/layouts/product-overlay-template";
import SiteActivation from "@/components/signup/site-activation";
import { useLoggedInHasJira } from "@/components/user-context";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    CreateASiteHeading,
    CreateASiteText,
    Headings,
    SitesAreSharedSpacesText
} from "../../../components";

export const LoggedInJpdNewUser = () => {
    const { ref } = useInView();
    const isLoggedInHasJira = useLoggedInHasJira();

    if (isLoggedInHasJira) {
        return (
            <div ref={ref}>
                <JiraOverlayTemplate size="sm">
                    <Content />
                </JiraOverlayTemplate>
            </div>
        );
    } else {
        return (
            <div ref={ref}>
                <JPDOverlayTemplate size="sm">
                    <Content />
                </JPDOverlayTemplate>
            </div>
        );
    }
};

const Content = () => {
    const { formatMessage } = useIntl();

    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    return (
        <>
            {team26VisualUpdates ? (
                <Headings
                    main={<CreateASiteText />}
                    sub={<SitesAreSharedSpacesText />}
                />
            ) : (
                <>
                    <h1 css={headerCss}>
                        <span css={accentImageSpanCss}>
                            <CreateASiteHeading />
                        </span>
                    </h1>
                    <p css={subHeaderCss}>
                        <SitesAreSharedSpacesText />
                    </p>
                </>
            )}
            <SiteActivation />
            <footer css={footerCss}>
                {formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage:
                        "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })}
            </footer>
        </>
    );
};

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const subHeaderCss = css({
    margin: "16px 0 16px 0",
    textAlign: "center",
    fontFamily: "Charlie Text",
    fontSize: 16
});

const accentImageSpanCss = css({
    position: "relative"
});

const footerCss = css({
    fontSize: 12,
    fontWeight: 400,
    margin: 0,
    fontFamily: "Charlie Text"
});
